import React from 'react';

function Contact() {
  return (
    <div className="page-container">
      <div className="header-container">Contact</div>
      <div className="text-container">
        Please reach out to us at{' '}
        <a href="mailto:info@metrodesign.us">info@metrodesign.us</a>
      </div>
    </div>
  );
}

export default Contact;
